import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { toast } from 'react-toastify';
import { useJsApiLoader } from '@react-google-maps/api';

import { QueryClient, QueryClientProvider } from 'react-query';
import { Toaster } from 'components/ui/toaster';
import { Routes } from 'routes';
import { store, persistor } from './store';
import Warden from 'Warden';
import GlobalStyle from './styles/global';

toast.configure();

const API_KEY = process.env.REACT_APP_GOOGLE_API_KEY_SINERGIA as string;
const MAP_ID = '87412a572f003751';

const App: React.FC = () => {

  const { loadError } = useJsApiLoader({
    id: 'google-maps-script',
    googleMapsApiKey: API_KEY,
    mapIds: [MAP_ID],
    libraries: ['maps'],
  });

  if (loadError) {
    console.error('Failed to load Google Maps API:', loadError);
  }

  return (
    <Provider store={store}>
      <Toaster />
      <PersistGate loading={null} persistor={persistor}>
        <Warden />
        <BrowserRouter>
          <GlobalStyle />
          <QueryClientProvider client={new QueryClient()}>
            <Routes />
          </QueryClientProvider>
        </BrowserRouter>
      </PersistGate>
    </Provider>
  );
};

export default App;
